import isEmpty from "lodash/isEmpty";
import type { IProductLean } from "../../../pages/ProductsListPage/entities/product-lean/product-lean.entity.interface";
import type { IProduct as IProductNew } from "../../../pages/ProductsListPage/entities/product/product.entity.interface";
import { SearchResultItem } from "./components/SearchResultItem";
import { serviceToResultItem } from "./utils/serviceToResultItem";
export interface ServicesFoundProps {
  keyPrefix: string;
  services: IProductLean[] | IProductNew[];
  goToService: (url: string) => void;
}

export function ServicesFound({ services, goToService, keyPrefix }: Readonly<ServicesFoundProps>) {
  return <>{services.map(toSearchItem.bind(null, keyPrefix, goToService))}</>;
}

function toSearchItem(
  keyPrefix: string,
  goToService: (url: string) => void,
  service: IProductLean | IProductNew
): JSX.Element | null {
  const key = `${keyPrefix}-${service.id}`;
  const item = serviceToResultItem(service);

  if (isEmpty(item.label)) {
    return null;
  }

  return <SearchResultItem key={key} item={item} goToService={goToService} />;
}
